import request from '@/utils/request'

// 查询森林树种列表
export function listForestTree(query) {
  return request({
    url: '/admin/forest/tree/list',
    method: 'get',
    params: query
  })
}

// 查询森林树种详细
export function getForestTree(treeId) {
  return request({
    url: '/admin/forest/tree/getInfo?treeId=' + treeId,
    method: 'get'
  })
}

// 新增森林树种
export function addForestTree(data) {
  return request({
    url: '/admin/forest/tree',
    method: 'post',
    data: data
  })
}

// 修改森林树种
export function updateForestTree(data) {
  return request({
    url: '/admin/forest/tree',
    method: 'put',
    data: data
  })
}

// 删除森林树种
export function delForestTree(treeId) {
  return request({
    url: '/admin/forest/tree/deleteTree?treeId=' + treeId,
    method: 'delete'
  })
}
